import { render, staticRenderFns } from "./RepairRegistrationSCList.vue?vue&type=template&id=0967c59e&"
import script from "./RepairRegistrationSCList.vue?vue&type=script&lang=js&"
export * from "./RepairRegistrationSCList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports